var map = {
	"./sizzle.mp4": 4029,
	"./sizzle2.mp4": 6919,
	"./sizzle2mobile.mp4": 2817,
	"./sizzle3.mp4": 1664,
	"./sizzle3mobile.mp4": 1013,
	"./sizzle4.mp4": 4406,
	"./sizzle4mobile.mp4": 8927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;